import { EventMasterActionConst } from "../Constants/EventMasterConstants";
import { BASE_URL, API_ENDPOINTS } from "../../config/api.config";
import { handleAuthError } from "../../utils/authUtils";

const buildHeaders = () => {
  const token = localStorage.getItem("accessToken");
  const headers = new Headers();
  headers.append("Content-Type", "application/json");
  headers.append("Authorization", `Bearer ${token}`);
  return headers;
};

export const FetchAllEventsAction = () => {
  return async (dispatch) => {
    dispatch({ type: EventMasterActionConst.FETCH_ALL_EVENTS_REQUEST });

    fetch(`${BASE_URL}${API_ENDPOINTS.EVENTS}`, {
      method: "GET",
      headers: buildHeaders(),
      redirect: "follow",
    })
      .then(async (response) => {
        const result = await response.json();
        const httpStatus = response.status;
        if (handleAuthError(result, httpStatus, dispatch)) return;
        if (result.statusCode === 200) {
          dispatch({ type: EventMasterActionConst.FETCH_ALL_EVENTS_SUCC, result });
        } else {
          dispatch({ type: EventMasterActionConst.FETCH_ALL_EVENTS_FAIL, result });
        }
      })
      .catch((error) => {
        dispatch({
          type: EventMasterActionConst.FETCH_ALL_EVENTS_FAIL,
          result: { statusCode: 500, data: null, message: error.message || "Network error occurred" },
        });
      });
  };
};

export const FetchEventDetailAction = (id) => {
  return async (dispatch) => {
    dispatch({ type: EventMasterActionConst.FETCH_EVENT_DETAIL_REQUEST });

    fetch(`${BASE_URL}${API_ENDPOINTS.EVENT_DETAIL(id)}`, {
      method: "GET",
      headers: buildHeaders(),
      redirect: "follow",
    })
      .then(async (response) => {
        const result = await response.json();
        const httpStatus = response.status;
        if (handleAuthError(result, httpStatus, dispatch)) return;
        if (result.statusCode === 200) {
          dispatch({ type: EventMasterActionConst.FETCH_EVENT_DETAIL_SUCC, result });
        } else {
          dispatch({ type: EventMasterActionConst.FETCH_EVENT_DETAIL_FAIL, result });
        }
      })
      .catch((error) => {
        dispatch({
          type: EventMasterActionConst.FETCH_EVENT_DETAIL_FAIL,
          result: { statusCode: 500, data: null, message: error.message || "Network error occurred" },
        });
      });
  };
};

export const FetchEventCollaborationAction = (id) => {
  return async (dispatch) => {
    dispatch({ type: EventMasterActionConst.FETCH_EVENT_COLLABORATION_REQUEST });

    fetch(`${BASE_URL}${API_ENDPOINTS.EVENT_COLLABORATION(id)}`, {
      method: "GET",
      headers: buildHeaders(),
      redirect: "follow",
    })
      .then(async (response) => {
        const result = await response.json();
        const httpStatus = response.status;
        if (handleAuthError(result, httpStatus, dispatch)) return;
        if (result.statusCode === 200) {
          dispatch({ type: EventMasterActionConst.FETCH_EVENT_COLLABORATION_SUCC, result });
        } else {
          dispatch({ type: EventMasterActionConst.FETCH_EVENT_COLLABORATION_FAIL, result });
        }
      })
      .catch((error) => {
        dispatch({
          type: EventMasterActionConst.FETCH_EVENT_COLLABORATION_FAIL,
          result: { statusCode: 500, data: null, message: error.message || "Network error occurred" },
        });
      });
  };
};

export const UpdateEventAction = (id, updateData) => {
  return async (dispatch) => {
    dispatch({ type: EventMasterActionConst.UPDATE_EVENT_REQUEST });

    fetch(`${BASE_URL}${API_ENDPOINTS.UPDATE_EVENT(id)}`, {
      method: "PATCH",
      headers: buildHeaders(),
      body: JSON.stringify(updateData),
      redirect: "follow",
    })
      .then(async (response) => {
        const result = await response.json();
        const httpStatus = response.status;
        if (handleAuthError(result, httpStatus, dispatch)) return;
        if (response.ok && (result.statusCode === 200 || result.statusCode === 201)) {
          dispatch({ type: EventMasterActionConst.UPDATE_EVENT_SUCC, result, id });
        } else {
          dispatch({ type: EventMasterActionConst.UPDATE_EVENT_FAIL, result });
        }
      })
      .catch((error) => {
        dispatch({
          type: EventMasterActionConst.UPDATE_EVENT_FAIL,
          result: { statusCode: 500, data: null, message: error.message || "Network error occurred" },
        });
      });
  };
};

export const PublishEventAction = (id) => {
  return async (dispatch) => {
    dispatch({ type: EventMasterActionConst.PUBLISH_EVENT_REQUEST });

    fetch(`${BASE_URL}${API_ENDPOINTS.PUBLISH_EVENT(id)}`, {
      method: "PATCH",
      headers: buildHeaders(),
      redirect: "follow",
    })
      .then(async (response) => {
        const result = await response.json();
        const httpStatus = response.status;
        if (handleAuthError(result, httpStatus, dispatch)) return;
        if (result.statusCode === 200) {
          dispatch({ type: EventMasterActionConst.PUBLISH_EVENT_SUCC, result, id });
        } else {
          dispatch({ type: EventMasterActionConst.PUBLISH_EVENT_FAIL, result });
        }
      })
      .catch((error) => {
        dispatch({
          type: EventMasterActionConst.PUBLISH_EVENT_FAIL,
          result: { statusCode: 500, data: null, message: error.message || "Network error occurred" },
        });
      });
  };
};

export const RemoveEventAction = (id) => {
  return async (dispatch) => {
    dispatch({ type: EventMasterActionConst.REMOVE_EVENT_REQUEST });

    fetch(`${BASE_URL}${API_ENDPOINTS.REMOVE_EVENT(id)}`, {
      method: "DELETE",
      headers: buildHeaders(),
      redirect: "follow",
    })
      .then(async (response) => {
        const result = await response.json();
        const httpStatus = response.status;
        if (handleAuthError(result, httpStatus, dispatch)) return;
        if (result.statusCode === 200) {
          dispatch({ type: EventMasterActionConst.REMOVE_EVENT_SUCC, result, id });
        } else {
          dispatch({ type: EventMasterActionConst.REMOVE_EVENT_FAIL, result });
        }
      })
      .catch((error) => {
        dispatch({
          type: EventMasterActionConst.REMOVE_EVENT_FAIL,
          result: { statusCode: 500, data: null, message: error.message || "Network error occurred" },
        });
      });
  };
};

export const FetchFlaggedEventsAction = () => {
  return async (dispatch) => {
    dispatch({ type: EventMasterActionConst.FETCH_FLAGGED_EVENTS_REQUEST });

    fetch(`${BASE_URL}${API_ENDPOINTS.FLAGGED_EVENTS}`, {
      method: "GET",
      headers: buildHeaders(),
      redirect: "follow",
    })
      .then(async (response) => {
        const result = await response.json();
        const httpStatus = response.status;
        if (handleAuthError(result, httpStatus, dispatch)) return;
        if (result.statusCode === 200) {
          dispatch({ type: EventMasterActionConst.FETCH_FLAGGED_EVENTS_SUCC, result });
        } else {
          dispatch({ type: EventMasterActionConst.FETCH_FLAGGED_EVENTS_FAIL, result });
        }
      })
      .catch((error) => {
        dispatch({
          type: EventMasterActionConst.FETCH_FLAGGED_EVENTS_FAIL,
          result: { statusCode: 500, data: null, message: error.message || "Network error occurred" },
        });
      });
  };
};

export const SetFlagDecisionAction = (id, decision) => {
  return async (dispatch) => {
    dispatch({ type: EventMasterActionConst.FLAG_DECISION_REQUEST });

    fetch(`${BASE_URL}${API_ENDPOINTS.FLAGGED_EVENT_DECISION(id)}`, {
      method: "PATCH",
      headers: buildHeaders(),
      body: JSON.stringify({ decision }),
      redirect: "follow",
    })
      .then(async (response) => {
        const result = await response.json();
        const httpStatus = response.status;
        if (handleAuthError(result, httpStatus, dispatch)) return;
        if (result.statusCode === 200) {
          dispatch({ type: EventMasterActionConst.FLAG_DECISION_SUCC, result, id, decision });
        } else {
          dispatch({ type: EventMasterActionConst.FLAG_DECISION_FAIL, result });
        }
      })
      .catch((error) => {
        dispatch({
          type: EventMasterActionConst.FLAG_DECISION_FAIL,
          result: { statusCode: 500, data: null, message: error.message || "Network error occurred" },
        });
      });
  };
};
